import { render, staticRenderFns } from "./ClientProjectsEditProposalsListItem.vue?vue&type=template&id=593438ae&"
import script from "./ClientProjectsEditProposalsListItem.vue?vue&type=script&lang=js&"
export * from "./ClientProjectsEditProposalsListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports